/* tslint:disable */

declare var Object: any;
export interface TipoPreguntaInterface {
  "id": number;
  "nombre": string;
  "descripcion"?: string;
  "generaRespuesta":number;
}

export class TipoPregunta implements TipoPreguntaInterface {
  "id": number;
  "nombre": string;
  "descripcion": string;
  "generaRespuesta":number;
  constructor(data?: TipoPreguntaInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TipoPregunta`.
   */
  public static getModelName() {
    return "TipoPregunta";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TipoPregunta for dynamic purposes.
  **/
  public static factory(data: TipoPreguntaInterface): TipoPregunta{
    return new TipoPregunta(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TipoPregunta',
      plural: 'TipoPregunta',
      path: 'TipoPregunta',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "nombre": {
          name: 'nombre',
          type: 'string'
        },
        "descripcion": {
          name: 'descripcion',
          type: 'string'
        },
        "generaRespuesta": {
          name: 'generaRespuesta',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/TipoPregunta.ts